'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-radio-buttons/~/react/react.js
// module id = 1313
// module chunks = 0